












import { defineComponent } from '@vue/composition-api';

import { useMessages } from '@/base/app';
import MyApp from '@/base/app/components/MyApp.vue';

import TenantOwnTermsOfServiceDraft from '../components/organisms/TenantOwnTermsOfServiceDraft.vue';

export default defineComponent({
  name: 'AdminTenantOwnTermsOfServiceDraftPage',
  components: { MyApp, TenantOwnTermsOfServiceDraft },
  setup() {
    const msgs = useMessages({ prefix: 'admin.pages.tenantOwnTermsOfServiceDraftPage' });
    return { title: msgs.of('tenantOwnTermsOfServiceDraft') };
  },
});
